import { gql, graphql } from "react-apollo"
import { createKioskInput } from "../helpers"
import type { Kiosk } from "../types"
import type { OperationComponent, QueryProps, NamedProps } from "react-apollo"

const MUTATE_UPDATE_KIOSK = gql`
  mutation UpdateKiosk($id: ID!, $kiosk: KioskInput!) {
    updateKiosk(id: $id, kiosk: $kiosk) {
      id
      friendlyName
      shortName
      email
      language
      hidden
      latitude
      longitude
      usesVirtualKeyboard
      primarySensor {
        id
      }
      startsAt
      endsAt
    }
  }
`

type Response = {
  updateKiosk: {
    id: string,
    friendlyName: string,
    email: string,
    language: string,
    hidden: boolean,
    primarySensor: {
      id: string
    },
    startsAt: string,
    endsAt: string
  }
}

type Props = QueryProps & Response
type MappedProps = NamedProps<Props, { mutateUpdateKiosk: Props }>

const mutateUpdateKiosk: OperationComponent<
  Response,
  any,
  Props
> = graphql(MUTATE_UPDATE_KIOSK, {
  name: "mutateUpdateKiosk",
  props: ({ mutateUpdateKiosk }: MappedProps) => ({
    updateKiosk: (id: string, kiosk: Kiosk) =>
      mutateUpdateKiosk({
        variables: { id: id, kiosk: createKioskInput(kiosk) }
      })
  })
})

export default mutateUpdateKiosk



// WEBPACK FOOTER //
// ./src/Kiosks/queries/mutateUpdateKiosk.js